export const actions = {
  CANCEL: "CANCEL",
  OPEN_CONFIRMATION_MODAL: "OPEN_CONFIRMATION_MODAL",
  CLOSE_CONFIRMATION_MODAL: "CLOSE_CONFIRMATION_MODAL",
  PREPARE_TO_SAVE: "PREPARE_TO_SAVE",
};
